let judgmeReviewsMainContainer;
let hcLoader;
window.addEventListener("DOMContentLoaded", () => {
  judgmeReviewsMainContainer = document.querySelector("#judgeme_product_reviews");
  if (!judgmeReviewsMainContainer) {
    judgmeReviewsMainContainer = document.querySelector(".jdgm-all-reviews-widget");
    judgmeReviewsMainContainer.id = "judgeme_product_reviews";
  }
  judgmeReviewsMainContainer.style.display = "none";
  hcLoader = document.createElement("div");
  hcLoader.classList.add("hc-loader");
  judgmeReviewsMainContainer.parentElement.appendChild(hcLoader);
});

window.addEventListener("load", () => {
  if (judgmeReviewsMainContainer) {
    widgetOnLoad();
  }
});

function widgetOnLoad() {
  try {
    const config = { childList: true, subtree: true };
    const callback = (mutationsList, observer) => {
      const stars = document.querySelector(".jdgm-rev-widg__summary-stars") ?? document.querySelector(".jdgm-all-reviews__summary-stars");
      const totalReviews = document.querySelector(".jdgm-rev-widg__summary-text") ?? document.querySelector(".jdgm-all-reviews__summary-text");
      const header = document.querySelector(".jdgm-rev-widg__header") ?? document.querySelector(".jdgm-all-reviews__header");
      observer.disconnect();
      setTimeout(() => {
        onReviewLoaded(stars, totalReviews, header);
      }, 500);
    };
    const observer = new MutationObserver(callback);
    observer.observe(document.body, config);
  } catch (err) {
    setTimeout(changeJdgmDesignBody, 500);
    console.log(err);
  }
}

function onReviewLoaded(stars, totalReviews, header) {
  header?.querySelector(".jdgm-rev-widg__title")?.remove();
  header?.querySelector(".jdgm-rev-widg__summary")?.remove();
  header?.querySelector(".jdgm-all-reviews__summary")?.remove();
  header?.querySelector(".jdgm-histogram")?.remove();

  if (stars) {
    const div = document.createElement("div");
    const rowStars = document.querySelector(".jdgm-row-stars");
    if (rowStars) {
      div.innerHTML = `<div class="hc-header-rating-wrapper">
         ${stars.innerHTML.replace(" von 5", "")} 
          <span class="hc-total-reviews-text">(${totalReviews.innerHTML.replace("Basierend auf ", "" )})</span>
       </div>`;
      rowStars.append(div);
    }
  }

  const starAverage = document.querySelector(".hc-header-rating-wrapper .jdgm-rev-widg__summary-average") ?? document.querySelector(".hc-header-rating-wrapper .jdgm-all-reviews__summary-average");
  const newHeader = document.querySelector(".hc-header-rating-wrapper");
  const newHeaderStars = document.querySelectorAll(".hc-header-rating-wrapper .jdgm-star");
  if (starAverage && newHeader) {
    newHeaderStars?.forEach((item) => {
      item?.remove();
    });

    const newSpan = document.createElement("span");
    newSpan.classList.add("hc-header-stars-container");
    newSpan.innerHTML = generateStars(parseFloat(starAverage.innerText));
    newHeader.insertBefore(newSpan, starAverage);
  }
  
  /* Image slider */
  setTimeout(sliderLoaded, 50);
  changeJdgmDesignBody();

  cdk.querySelector(".jdgm-row-actions .jdgm-sort-dropdown").then((element) => {
    element.addEventListener("change", () => {
      observerFn();
    });
  });
}

function changeJdgmDesignBody() {
  const header = document.querySelector(".jdgm-rev-widg__header") ?? document.querySelector(".jdgm-all-reviews__header");
  header?.querySelector(".jdgm-rev-widg__title")?.remove();
  header?.querySelector(".jdgm-rev-widg__summary")?.remove();
  header?.querySelector(".jdgm-all-reviews__summary")?.remove();
  header?.querySelector(".jdgm-histogram")?.remove();

  /* Cards */
  const reviewRating = document.querySelectorAll(".jdgm-rev__rating");

  /* Stars replacement */
  reviewRating.forEach((item) => {
    const score = parseInt(item.getAttribute("data-score"));
    item.innerHTML = generateStars(score);
  });

  document.querySelectorAll(".jdgm-row-profile .jdgm-rev__icon")?.forEach((item) => item?.remove());
  document.querySelectorAll(".jdgm-rev__author-wrapper .jdgm-row-extra")?.forEach((item) => item?.remove());

  /* Verified badge */
  document.querySelectorAll(".jdgm-rev__buyer-badge-wrapper")?.forEach((item) => {
    if (!item.querySelector(".hc-verified-badge")) {
      const verifiedBadge = document.createElement("div");
      verifiedBadge.classList.add("hc-verified-badge");
      verifiedBadge.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 24 22" fill="none">
            <path d="M2 13.1724L10.125 20L22 2" stroke="#FFFCF9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;
      item.insertBefore(verifiedBadge, item.querySelector(".jdgm-rev__buyer-badge"));
    }
  });

  document.querySelectorAll(".jdgm-row-rating .jdgm-rev__timestamp")?.forEach((item) => {
    const elementToDelete = item.parentElement;
    const year = item?.innerText.split("/").pop();
    item.innerText = item?.innerText.replace(year, `20${year}`).replaceAll("/", ".");
    const element = item?.parentElement.parentElement.previousElementSibling;
    element?.insertBefore(item.previousElementSibling, element.children[0]);
    element?.appendChild(item);
    elementToDelete?.remove();
  });

  const thumbsUp = document.querySelectorAll(".jdgm-rev_thumb-up");
  thumbsUp?.forEach((item) => {
    item.innerHTML = `<svg class="hc-custom-thumb-arrows" xmlns="http://www.w3.org/2000/svg" width="26" height="38" viewBox="0 0 26 38" fill="none">
        <path d="M13 36L13 2M13 2L24 13M13 2L2 13" stroke="#4D2400" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
  });

  const thumbsDown = document.querySelectorAll(".jdgm-rev_thumb-down");
  thumbsDown?.forEach((item) => {
    item.innerHTML = `<svg class="hc-custom-thumb-arrows" xmlns="http://www.w3.org/2000/svg" width="26" height="38" viewBox="0 0 26 38" fill="none">
        <path d="M13 2L13 36M13 36L2 25M13 36L24 25" stroke="#4D2400" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
  });

  if (window.innerWidth <= 991) {
    try {
      const divider = document.querySelectorAll(".jdgm-rev__header-custom-form .jdgm-rev__cf-ans--type");
      divider.forEach((item) => {
        if (!item.classList.contains("hc-divider-implemented")) {
          item.style = "display: flex; gap: .375rem;";
          const span = document.createElement("span");
          span.textContent = "/";
          item.insertBefore(span, item.querySelector(".jdgm-rev__cf-ans:last-child"));
          item.classList.add("hc-divider-implemented");
        }
      });
  
      document.querySelectorAll(".jdgm-rev__timestamp")?.forEach((item) => {
        const mbJdgmHeader = item.parentElement;
        if(mbJdgmHeader.classList.contains("jdgm-rev__header") && !mbJdgmHeader.querySelector(".mobile-rating-timestamp")) {
          const mbJudgmRating = mbJdgmHeader.querySelector(".jdgm-rev__rating");
          const newDiv = document.createElement("div");
          newDiv.classList.add("mobile-rating-timestamp");
          newDiv.innerHTML = `<div>${mbJudgmRating.innerHTML}</div> ${item.innerHTML}`;
          mbJdgmHeader?.insertBefore(newDiv, mbJudgmRating);
          mbJudgmRating?.remove();
          item?.remove();
        }
      });
    }
    catch(err) {
      console.log(err);
    }
  }

  /* Load more event */
  document.querySelector(".jdgm-paginate__load-more")?.addEventListener("click", observerFn);

  document.querySelector(".jdgm-all-reviews-page__load-more")?.addEventListener("click", observerFn);

  /* Subtab event */
  document.querySelectorAll(".jdgm-subtab__name").forEach((item) => {
    item?.addEventListener("click", observerFn);
  });

  /* Open image modal event */
  const imagesModal = document.querySelectorAll(".jdgm-rev__pic-link .jdgm-rev__pic-img");
  imagesModal.forEach((item) => {
    item.addEventListener("click", () => {
      setTimeout(changeButtonImageView, 50)
    });
  });

  hcLoader?.remove();
  judgmeReviewsMainContainer.style.display = "block";
}

function createFullStar() {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="71" height="68" viewBox="0 0 71 68" fill="none">
    <path d="M34.7379 0.974886C35.0346 0.0480833 36.346 0.048085 36.6427 0.974888L44.1552 24.441C44.2877 24.8551 44.6727 25.1361 45.1075 25.1361H69.4496C70.4147 25.1361 70.8198 26.3682 70.043 26.9409L50.3246 41.4811C49.9793 41.7357 49.8349 42.1822 49.9657 42.5908L57.4914 66.0984C57.7872 67.0223 56.7263 67.7839 55.9455 67.2081L36.2838 52.7098C35.9309 52.4496 35.4497 52.4496 35.0968 52.7098L15.435 67.2081C14.6542 67.7839 13.5934 67.0223 13.8892 66.0984L21.4149 42.5908C21.5457 42.1822 21.4013 41.7357 21.056 41.4811L1.33755 26.9409C0.560764 26.3681 0.9659 25.1361 1.93103 25.1361H26.273C26.7079 25.1361 27.0929 24.8551 27.2254 24.441L34.7379 0.974886Z" fill="#5A2A00"/>
  </svg>`;
}

function createHalfStar() {
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="293" height="283" viewBox="0 0 293 283">
    <image id="Capa_1" data-name="Capa 1" x="2" y="1" width="169" height="280" xlink:href="data:img/png;base64,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"/>
    <image id="Capa_2" data-name="Capa 2" x="2" y="65" width="291" height="216" xlink:href="data:img/png;base64,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"/>
  </svg>`;
}

function createEmptyStar() {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="71" height="68" viewBox="0 0 71 68" fill="none">
    <path d="M34.3531 0.974886C34.6498 0.0480833 35.9612 0.048085 36.2579 0.974888L43.7704 24.441C43.903 24.8551 44.2879 25.1361 44.7228 25.1361H69.0648C70.0299 25.1361 70.4351 26.3682 69.6583 26.9409L49.9398 41.4811C49.5945 41.7357 49.4501 42.1822 49.5809 42.5908L57.1066 66.0984C57.4024 67.0223 56.3416 67.7839 55.5608 67.2081L35.899 52.7098C35.5461 52.4496 35.0649 52.4496 34.712 52.7098L15.0503 67.2081C14.2695 67.7839 13.2086 67.0223 13.5044 66.0984L21.0302 42.5908C21.161 42.1822 21.0166 41.7357 20.6713 41.4811L0.952782 26.9409C0.175999 26.3681 0.581135 25.1361 1.54627 25.1361H25.8883C26.3231 25.1361 26.7081 24.8551 26.8407 24.441L34.3531 0.974886Z" fill="#5A2A00" fill-opacity="0.2"/>
  </svg>`;
}

function generateStars(score) {
  let starsHTML = "";
  const fullStars = Math.floor(score);
  const remainder = score - fullStars;
  let halfStar = 0;
  let emptyStars = 5 - fullStars;

  if (remainder >= 0.75) {
    halfStar = 1;
    emptyStars -= 1;
  } else if (remainder >= 0.25 && remainder < 0.75) {
    halfStar = 1;
    emptyStars -= 1;
  }

  for (let i = 0; i < fullStars; i++) {
    starsHTML += createFullStar();
  }

  if (halfStar) {
    starsHTML += createHalfStar();
  }

  for (let i = 0; i < emptyStars; i++) {
    starsHTML += createEmptyStar();
  }

  return starsHTML;
}

function modalViewer() {
  cdk.querySelector(".jm-mfp-main .jdgm-row-rating").then(() => {
    const modalTimeStamp = document.querySelector(".jm-mfp-main .jdgm-rev__timestamp");
    if (modalTimeStamp && !modalTimeStamp.hasAttribute("data-original-text")) {
      modalTimeStamp.setAttribute("data-original-text", modalTimeStamp.innerText);
      const modalScore = document.querySelector(".jm-mfp-main .jdgm-rev__rating");
      const score = parseInt(modalScore?.getAttribute("data-score"));
      modalScore.innerHTML = generateStars(score);
      const originalText = modalTimeStamp?.getAttribute("data-original-text");
      const year = originalText?.split("/").pop();
      const textFinished = originalText?.replace(year, `20${year}`).replaceAll("/", ".");
      modalTimeStamp.innerText = textFinished;
      const modalHeader = modalTimeStamp.closest(".jdgm-rev__header");
      modalHeader.appendChild(modalTimeStamp);
      document.querySelector(".jm-mfp-close").innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M1 1L17 17" stroke="#4D2400" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M17 1L1 15.9333" stroke="#4D2400" stroke-width="1.5" stroke-linecap="round"/>
      </svg>`;
    
      const authorData = document.querySelector(".jm-mfp-main .jdgm-rev__custom-form");
    
      const authorName = document.querySelector(".jdgm-row-profile .jdgm-rev__author");
      if(authorName && authorData) {
        authorName.parentElement.appendChild(authorData);
      }
    
      const verifiedText = document.querySelector(".jm-mfp-main .jdgm-rev__buyer-badge");
      if (verifiedText && !document.querySelector(".jm-mfp-main .hc-verified-badge")) {
        const verifiedBadge = document.createElement("div");
        verifiedBadge.classList.add("hc-verified-badge");
        verifiedBadge.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 24 22" fill="none">
          <path d="M2 13.1724L10.125 20L22 2" stroke="#FFFCF9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
        verifiedText.append(verifiedBadge);
      }
    
      if (window.innerWidth <= 991) {
        authorData.innerHTML = authorData.innerText.replace("Hauttyp", "/ Hauttyp");
      }
      customBtns();
      galleryImageOnModal();
    }
  });
}

function galleryImageOnModal() {
  const jdgmGallery = document.querySelector(".jdgm-gallery");
  let isDragging = false;
  let startX;
  let startScrollLeft;

  jdgmGallery.addEventListener("mousedown", handleMouseDown);
  jdgmGallery.addEventListener("mousemove", handleMouseMove);
  jdgmGallery.addEventListener("mouseup", handleMouseUp);
  jdgmGallery.addEventListener("mouseleave", handleMouseUp);

  jdgmGallery.addEventListener("touchstart", handleTouchStart);
  jdgmGallery.addEventListener("touchmove", handleTouchMove);
  jdgmGallery.addEventListener("touchend", handleTouchEnd);

  function handleMouseDown(e) {
    e.preventDefault();
    isDragging = true;
    startX = e.pageX;
    startScrollLeft = jdgmGallery.scrollLeft;
  }

  function handleMouseMove(e) {
    if (!isDragging) return;
    const x = e.pageX;
    const walk = (x - startX) * 2;
    jdgmGallery.scrollLeft = startScrollLeft - walk;
  }

  function handleMouseUp() {
    isDragging = false;
  }

  function handleTouchStart(e) {
    isDragging = true;
    startX = e.touches[0].pageX;
    startScrollLeft = jdgmGallery.scrollLeft;
  }

  function handleTouchMove(e) {
    e.preventDefault();
    if (!isDragging || e.touches.length > 1) {
      isDragging = false;
      return;
    }
    const x = e.touches[0].pageX;
    const walk = (x - startX) * 2;
    jdgmGallery.scrollLeft = startScrollLeft - walk;
  }

  function handleTouchEnd() {
    isDragging = false;
  }
}

function customBtns() {
  const buttonDivs = document.createElement("div");
  buttonDivs.innerHTML = `
    <div class="hc-arrow-modal-jdgm hc-arrow-modal-jdgm-left">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="38 28 15 30" fill="none">
        <path d="M53 57L38.9224 42.9224L53 28.8448" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </div>
    <div class="hc-arrow-modal-jdgm hc-arrow-modal-jdgm-right">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="166 26 20 32" fill="none">
        <path d="M169 29L183.078 43.0776L169 57.1552" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </div>
  `;

  if (window.innerWidth >= 992) {
    document.querySelector(".hc-arrow-modal-jdgm-container")?.remove();
    buttonDivs.classList.add("hc-arrow-modal-jdgm-container");
    document.querySelector(".jm-mfp-main .jm-mfp-review-wrapper").appendChild(buttonDivs);
  } else {
    document.querySelector(".hc-arrow-modal-jdgm-container-mobile")?.remove();
    buttonDivs.classList.add("hc-arrow-modal-jdgm-container-mobile");
    document.querySelector(".jm-mfp-main .jm-mfp-carousel-wrapper .jm-mfp-content-wrapper").appendChild(buttonDivs);
  }

  document.querySelectorAll(".hc-arrow-modal-jdgm").forEach((item) => {
    item.addEventListener("click", () => {
      const selectedImage = document.querySelector(".jm-mfp-carousel .jdgm-gallery__thumbnail-link--current");
      if (item.classList.contains("hc-arrow-modal-jdgm-left")) {
        const previousImage = selectedImage.previousElementSibling;
        if (previousImage) {
          previousImage.click();
        }
      } else {
        const nextImage = selectedImage.nextElementSibling;
        if (nextImage) {
          nextImage.click();
        }
      }
    });
  });

  thumbnailsChange();
}

function thumbnailsChange() {
  document.querySelectorAll(".jm-mfp-carousel .jdgm-gallery__thumbnail-link").forEach((item) => {
    item.addEventListener("click", () => { setTimeout(modalViewer, 50); });
  });
  document.querySelector(".jm-mfp-img").addEventListener("click", () => { setTimeout(modalViewer, 50); });
}

function changeButtonImageView() {
  cdk.querySelector(".jm-mfp-gallery .jm-mfp-image-holder .jm-mfp-close").then(element => {
    element.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M1 1L17 17" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M17 1L1 15.9333" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/>
          </svg>`;
    const svg = element.querySelector("svg");
    svg.addEventListener("click", () => {
      svg.parentElement.click();
    });
  });
}

function sliderLoaded() {
  const galleryWrapper = judgmeReviewsMainContainer.querySelector(".jdgm-gallery-wrapper");
  if (galleryWrapper) {
    const progressiveBar = document.createElement("div");
    progressiveBar.classList.add("progressive-bar");
    const progressBarFill = document.createElement("div");
    progressBarFill.classList.add("progressive-bar-fill");
    progressiveBar.appendChild(progressBarFill);
    galleryWrapper?.append(progressiveBar);

    /* Draggable */
    const jdgmGalleryDraggable = document.querySelector(".jdgm-gallery");
    let isDragging = false;
    let startX;
    let scrollLeft;

    jdgmGalleryDraggable.addEventListener("mousedown", handleDragStart);
    jdgmGalleryDraggable.addEventListener("touchstart", handleDragStart);

    document.addEventListener("mousemove", handleDrag);
    document.addEventListener("touchmove", handleDrag);

    document.addEventListener("mouseup", handleDragEnd);
    document.addEventListener("touchend", handleDragEnd);

    jdgmGalleryDraggable.addEventListener("mouseleave", handleDragEnd);

    function handleDragStart(e) {
      isDragging = true;
      jdgmGalleryDraggable.classList.add("active");

      if (e.type === "mousedown") {
        startX = e.pageX - jdgmGalleryDraggable.offsetLeft;
      } else if (e.type === "touchstart") {
        startX = e.touches[0].pageX - jdgmGalleryDraggable.offsetLeft;
      }

      scrollLeft = jdgmGalleryDraggable.scrollLeft;
    }

    function handleDrag(e) {
      if (!isDragging) return;
      e.preventDefault();

      jdgmGalleryDraggable.classList.add("active");

      let x;

      if (e.type === "mousemove") {
        x = e.pageX - jdgmGalleryDraggable.offsetLeft;
      } else if (e.type === "touchmove") {
        x = e.touches[0].pageX - jdgmGalleryDraggable.offsetLeft;
      }

      const walk = (x - startX) * 2;
      jdgmGalleryDraggable.scrollLeft = scrollLeft - walk;
      updateProgressBar();
    }

    function handleDragEnd() {
      isDragging = false;
      jdgmGalleryDraggable.classList.remove("active");
      updateProgressBar();
    }

    function updateProgressBar() {
      const jdgmGalleryDraggable = document.querySelector(".jdgm-gallery");
      const visibleWidth = jdgmGalleryDraggable.clientWidth;
      const widthReference = document.querySelector(".jdgm-gallery__thumbnail-link").clientWidth;
      const totalWidth =widthReference * document.querySelectorAll(".jdgm-gallery__thumbnail-link").length;
      const maxScrollableWidth = Math.max(1, jdgmGalleryDraggable.scrollWidth - jdgmGalleryDraggable.clientWidth);
      const currentScroll = jdgmGalleryDraggable.scrollLeft;
      const visiblePercentage = (visibleWidth / totalWidth) * 100;
      const scrolledPercentage = (currentScroll / maxScrollableWidth) * (100 - visiblePercentage);
      progressBarFill.style.width = `${Math.min(visiblePercentage + scrolledPercentage, 100)}%`;
    }

    updateProgressBar();
    window.addEventListener("resize", updateProgressBar);

    document.querySelectorAll(".jdgm-row-media .jdgm-gallery-wrapper .jdgm-gallery__thumbnail-link").forEach((element) => {
      element.addEventListener("click", () => {
        modalViewer();
        updateProgressBar();
      });
    });
  }
}

function observerFn() {
  const observer = new MutationObserver((mutationsList, observer) => {
    let lastIteration = false;
    for (let i = 0; i < mutationsList.length; i++) {
      const mutation = mutationsList[i];

      if (i === mutationsList.length - 1) {
        lastIteration = true;
      }
      if (lastIteration) {
        setTimeout(changeJdgmDesignBody, 50);
        observer.disconnect();
      }
    }
  });

  const config = {
    childList: true,
    subtree: true
  };

  observer.observe(document.querySelector(".jdgm-rev-widg") ?? document.querySelector(".jdgm-all-reviews-widget"), config);
}